// @flow
import * as React from 'react'
import styled from 'styled-components'

const InputLabel = ({ title, id }) => (
  <Wrapper>
    <label htmlFor={id}>{title}</label>
  </Wrapper>
)

const Wrapper = styled.div`
  position: absolute;
  left: 0;
  top: -25px;
  z-index: 3;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
`

export default InputLabel
